import type { Task } from '../schemas/task';

export function isOpenTask(task: Task): boolean {
  return task.status === 'todo' || task.status === 'doing';
}
